import React, { useEffect, useState } from "react";
import BoxComponent from "./BoxComponent";
import {
  TableCellsMerge,
  FileSliders,
  Bell,
  Sheet,
  GitGraph,
  ChartNoAxesCombined
} from "lucide-react";
import { Card } from "../ui/Card";
import { UsageTrend } from "./UsageTrend";
import axiosInstance from "../../../axiosInstanceSetup";
import axios from "axios";
import { FaArrowLeft, FaExternalLinkAlt } from "react-icons/fa";
import heartLoading from "../../../assests/heartLoading.gif";
import { ProfilingResultView } from "./ProfilingResult";
import { DQResult } from "./DQResult";
import KeyIcon from "@mui/icons-material/Key";
import Tooltip from "@mui/material/Tooltip";
import AssetConfiguration from "./AssetConfiguration";
import AssetDataTable from "./AssetDataTable";
import LineageModal from "../DataContract/LineageModal";
import SubscriptionModal from "../DataContract/SubscriptionModal";
import { toast, Toaster } from "react-hot-toast";
import LineageTransformationModal from "../DataContract/LineageTransformation/LineageTransformationModal";
import ERLandingPage from "../ERDiagram/pages/ERLandingPage";
import ViewLineage from "../DataContract/ViewLineage";
import ReactFlowFromMermaid from "../DataContract/LineageTransformation/ReactFlowFromMermaid";


const getTypeColor = (type) => {
  switch (type.toUpperCase()) {
    case "STRING":
      return "primary";
    case "INTEGER":
      return "success";
    case "DECIMAL":
      return "warning";
    case "DATE":
      return "error";
    default:
      return "secondary";
  }
};
const serviceNowTicketLink =
  "https://marsprod.service-now.com/sp?id=incident_helper";

export const AssetsDetails = ({
  subdomain,
  productDetails,
  profilingResult,
  dqResult,
  onBack,
  onL5Click,
}) => {
  const [activeTab, setActiveTab] = useState("Data Table");
  const [searchTerm, setSearchTerm] = useState("");
  const [assetOverview, setAssetOverview] = useState();
  const [tableOverview, setTableOverview] = useState();
  const [profilingResultByAsset, setProfilingResultByAsset] = useState(null);
  const [dqResultByAsset, setDQResultByAsset] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [showViewModal, setShowViewModal] = useState(false);
  const [transformLineageAsset, setTransformLineageAsset] = useState(null);
  const [mermaidDiagrams, setMermaidDiagrams] = useState(null);
const [mermaidTypes, setMermaidTypes] = useState(null);
const [selectedMermaid, setSelectedMermaid] = useState(null);
const [mermaidLoading, setMermaidLoading] = useState(false);

  // Lineage modal state
  const [showLineageModal, setShowLineageModal] = useState(false);
  const [selectedLineageForView, setSelectedLineageForView] = useState(null);

  // Subscription modal state
  const [showSubscriptionForm, setShowSubscriptionForm] = useState(false);
  const [subscriptionForm, setSubscriptionForm] = useState({
    productName: "",
    projectCode: "",
    readerGroup: "",
    usageDuration: "3months",
    usageDescription: "",
    notificationEmail: "",
    acceptTerms: false,
  });
  const [allFieldsValid, setAllFieldsValid] = useState(true);
  const [formTouched, setFormTouched] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [availableProducts, setAvailableProducts] = useState([]);
  const [editMetadata, setEditMetadata] = useState(false)
  const [usageTrendData, setUsageTrendData] = useState(null);
const [usageTrendLoading, setUsageTrendLoading] = useState(true);
  // console.log("subdomainAssetDetails", subdomain)

  const fetchAssetInformation = async () => {
    try {
      setIsLoading(true);

      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}/assets/${subdomain.data_asset_id}`,
      );

      if (response.status === 200) {
        setAssetOverview(response?.data?.assetsOverview);
        setTableOverview(response?.data?.tableDetails);
        setIsLoading(false);
      }
    } catch (e) {
      console.error("getting error whie fetching the asset information");
      setIsLoading(false);
    }
  };

  // Fetch products for subscription dropdown
  const fetchProducts = async () => {
    try {
      const payload = {
        parentDomain: "",
        domain: "",
        subDomain: "",
        product: "",
        searchValue: "",
        page: 1,
        pageSize: 10,
      };

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/data-discovery-results`,
        payload,
      );

      if (
        response.data &&
        response.data.filters &&
        response.data.filters.parent_domains
      ) {
        // Extract ALL products from the hierarchical filter structure
        const allProducts = [];
        response.data.filters.parent_domains.forEach((pd) => {
          pd.domains.forEach((d) => {
            d.sub_domains.forEach((sd) => {
              sd.products.forEach((p) => {
                if (!allProducts.includes(p)) {
                  allProducts.push(p);
                }
              });
            });
          });
        });
        setAvailableProducts(allProducts);
      }
    } catch (e) {
      console.error("Error fetching products for subscription:", e);
    }
  };

  const fetchLineageTransformation = async (assetName) => {
  try {
    setMermaidLoading(true);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/lineage-transformation?asset_name=${assetName}`
    );
    if (response?.data) {
      setMermaidDiagrams(response.data.mermaid_diagrams);
      const types = response.data.mermaid_diagrams.map((d) => d.name);
      setMermaidTypes(types);
      setSelectedMermaid(response.data.mermaid_diagrams[0]);
    }
  } catch (err) {
    console.error(err);
  } finally {
    setMermaidLoading(false);
  }
};
 
const handleSelectMermaid = (mermaidName) => {
  setMermaidLoading(true);
  setTimeout(() => {
    const _selected = mermaidDiagrams.find((d) => d.name === mermaidName);
    setSelectedMermaid(_selected);
    setMermaidLoading(false);
  }, 500);
};

useEffect(() => {
  if (activeTab === "Transformation Lineage") {
    fetchLineageTransformation(subdomain.data_asset_name);
  }
}, [activeTab]);

useEffect(() => {
  if (activeTab === "Usage Trend") {
    const fetchUsageTrend = async () => {
      try {
        setUsageTrendLoading(true);
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/data_insights/${subdomain.data_asset_id}`
        );
        if (response.status === 200) {
          setUsageTrendData(response.data.graph_data);
        }
      } catch (err) {
        console.error("Error fetching usage trend:", err);
        setUsageTrendData({});
      } finally {
        setUsageTrendLoading(false);
      }
    };
    fetchUsageTrend();
  }
}, [activeTab]);

  useEffect(() => {
    fetchAssetInformation();
    fetchProducts(); // Fetch products for subscription dropdown
    const filteredRows = profilingResult?.filter(
      (res) =>
        res.data_asset_name.toLowerCase() ===
        subdomain.data_asset_name.toLowerCase(),
    );
    setProfilingResultByAsset(filteredRows[0]);
    const filteredDQRows = dqResult?.find(
      (res) => res.data_asset_id === subdomain.data_asset_id,
    );
    const filteredRules = filteredDQRows.rules.filter(
      (rule) => rule.rule_name !== "row_count",
    );
    setDQResultByAsset({ ...filteredDQRows, rules: filteredRules });
  }, []);

  useEffect(() => {
    fetchAssetInformation()
  },[editMetadata])

  // Update allFieldsValid whenever form or errors change
  useEffect(() => {
    const isValid =
      subscriptionForm.productName &&
      subscriptionForm.readerGroup &&
      subscriptionForm.usageDuration &&
      subscriptionForm.usageDescription &&
      subscriptionForm.notificationEmail &&
      Object.keys(formErrors).length === 0;
    setAllFieldsValid(isValid);
  }, [subscriptionForm, formErrors]);

  if (isLoading) {
    return (
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50 w-full h-full">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..." className="h-30" />
          <span className="text-gray-700 text-[20px]">
            Please wait while loading the resources...
          </span>
        </div>
      </div>
    );
  }

  const filteredAttributes =
    tableOverview &&
    tableOverview.filter(
      (attr) =>
        attr.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        attr.type.toLowerCase().includes(searchTerm.toLowerCase()),
    );

  const tabs = [
    { id: "Data Table", label: "Assets Table", icon: TableCellsMerge },
    { id: "Data Configuration", label: "Asset Configuration", icon: Sheet },
    { id: "Profiling Result", label: "Profiling Result", icon: FileSliders },
    { id: "DQResult", label: "Data Quality Result", icon: FileSliders },
    { id: "Technical Lineage", label: "Technical Lineage", icon: GitGraph },

    {
      id: "Transformation Lineage",
      label: "Transformation Lineage",
      icon: GitGraph,
    },
            { id: "Usage Trend", label: "Usage Trend", icon: ChartNoAxesCombined},

  ];

  const assetData = assetOverview;

  const totalPages =
    filteredAttributes &&
    Math.max(1, Math.ceil(filteredAttributes.length / itemsPerPage));

  const validCurrentPage = Math.min(currentPage, totalPages);

  const indexOfFirstItem = (validCurrentPage - 1) * itemsPerPage;
  const indexOfLastItem =
    filteredAttributes &&
    Math.min(indexOfFirstItem + itemsPerPage, filteredAttributes.length);
  const currentSubdomains =
    filteredAttributes &&
    filteredAttributes.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPaginationButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(
      1,
      validCurrentPage - Math.floor(maxVisiblePages / 2),
    );
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    buttons.push(
      <button
        key="prev"
        className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        disabled={validCurrentPage === 1}
        onClick={() => handlePageChange(validCurrentPage - 1)}
      >
        Previous
      </button>,
    );

    if (startPage > 1) {
      buttons.push(
        <button
          key={1}
          className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          onClick={() => handlePageChange(1)}
        >
          1
        </button>,
      );
      if (startPage > 2) {
        buttons.push(
          <span key="ellipsis1" className="px-3 py-2 text-sm text-gray-500">
            ...
          </span>,
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          className={`px-3 py-2 text-sm border rounded-md transition-colors ${
            validCurrentPage === i
              ? "bg-blue-500 text-white border-blue-500 shadow-sm"
              : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </button>,
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="ellipsis2" className="px-3 py-2 text-sm text-gray-500">
            ...
          </span>,
        );
      }
      buttons.push(
        <button
          key={totalPages}
          className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </button>,
      );
    }

    buttons.push(
      <button
        key="next"
        className="px-3 py-2 text-sm border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        disabled={validCurrentPage === totalPages}
        onClick={() => handlePageChange(validCurrentPage + 1)}
      >
        Next
      </button>,
    );

    return buttons;
  };

  const parseWeightage = (weightageStr) => {
    try {
      return JSON.parse(weightageStr);
    } catch {
      return {};
    }
  };

  const weightage =
    assetData && assetData.weightage && parseWeightage(assetData.weightage);

  // Handle tab click - special handling for Technical Lineage
 const handleTabClick = (tabId) => {
  setActiveTab(tabId);  // just switch tab for both, no modals
}

  // Subscription handlers
  const handleSubscribe = () => {
    setShowSubscriptionForm(true);
  };

  const closeSubsciptionModal = () => {
    setFormTouched(false);
    setShowSubscriptionForm(false);
    setSubscriptionForm({
      productName: "",
      projectCode: "",
      readerGroup: "",
      usageDuration: "3months",
      usageDescription: "",
      notificationEmail: "",
      acceptTerms: false,
    });
    setFormErrors({});
  };

  const handleSubscriptionChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setSubscriptionForm((prev) => ({ ...prev, [name]: newValue }));

    // Real-time validation for email field
    if (name === "notificationEmail" && value) {
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(value)) {
        setFormErrors((prev) => ({
          ...prev,
          notificationEmail: "Only @effem.com email addresses are allowed",
        }));
      } else {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.notificationEmail;
          return newErrors;
        });
      }
    }
  };

  const validateConfigForm = (formData = subscriptionForm) => {
    const errors = {};
    if (!formData.productName) errors.productName = "Required";
    if (!formData.readerGroup) errors.readerGroup = "Required";
    if (!formData.usageDuration) errors.usageDuration = "Required";
    if (!formData.usageDescription) errors.usageDescription = "Required";
    if (!formData.notificationEmail) {
      errors.notificationEmail = "Required";
    } else {
      const emailRegex = /^[^\s@]+@effem\.com$/;
      if (!emailRegex.test(formData.notificationEmail)) {
        errors.notificationEmail =
          "Only @effem.com email addresses are allowed";
      }
    }
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubscriptionSubmit = () => {
    const trimmedForm = {
      ...subscriptionForm,
      productName: subscriptionForm.productName.trim(),
      projectCode: subscriptionForm.projectCode?.trim() || "",
      readerGroup: subscriptionForm.readerGroup.trim(),
      usageDescription: subscriptionForm.usageDescription.trim(),
      notificationEmail: subscriptionForm.notificationEmail.trim(),
    };

    setSubscriptionForm(trimmedForm);
    setFormTouched(true);
    if (!validateConfigForm(trimmedForm)) return;

    const requestDetails = {
      requestedBy: localStorage.getItem("userId"),
      usageDuration: trimmedForm.usageDuration,
      usageDescription: trimmedForm.usageDescription,
      readerGroup: trimmedForm.readerGroup,
      productName: trimmedForm.productName,
      projectCode: trimmedForm.projectCode || "",
      notificationEmail: trimmedForm.notificationEmail,
    };

    const requestPayload = {
      dataAssetId: subdomain.data_asset_id,
      requestDetails: requestDetails,
    };

    try {
      const response = axios.post(
        `${process.env.REACT_APP_API_URL}/subscription-request`,
        requestPayload,
      );

      if (response.status === 200 || 201) {
        closeSubsciptionModal();
      }

      toast.success("Subscription to the asset configured successfully!");
    } catch (error) {
      toast.error("Failed to subscribe to the asset. Please try again later.");
    }
  };

  // Get available products for subscription form
  const getAvailableProducts = () => {
    // Return fetched products from API
    if (availableProducts.length > 0) {
      return availableProducts;
    }
    // Fallback to current product if API hasn't returned yet
    if (productDetails?.productName) {
      return [productDetails.productName];
    }
    return subdomain.product_name ? [subdomain.product_name] : [];
  };

  return (
    <div className="space-y-8 ">
      <div className="rounded-lg pt-4 pb-4 text-white relative">
        <div className="flex justify-between items-center flex-wrap gap-4 mb-[5px]">
          <h1 className="text-[23px] font-bold text-black break-words whitespace-normal overflow-hidden max-w-[80%]">
            {subdomain.data_asset_name.replace(/\|/g, ".")}
          </h1>
        </div>
        <p className="text-lg text-black mb-4 leading-relaxed">
          {subdomain.asset_description}
        </p>
        <div className="flex justify-end mb-3 gap-2 items-center flex-wrap">
          <ERLandingPage />
          <div className="flex items-center gap-2">
            <a
              href={serviceNowTicketLink}
              target="_blank"
              className=" h-[40px] text-[#bb1ccc] hover:text-white transition-colors duration-200 border border-[#bb1ccc] p-2 rounded-lg flex items-center gap-2 hover:bg-[#bb1ccc] hover:shadow-lg px-4 whitespace-nowrap"
            >
              <FaExternalLinkAlt /> Raise an Incident
            </a>

            <button
              onClick={onBack}
              className=" h-[40px] text-[#bb1ccc] hover:text-white transition-colors duration-200 border border-[#bb1ccc] p-2 rounded-lg flex items-center gap-2 hover:bg-[#bb1ccc] hover:shadow-lg px-4 whitespace-nowrap"
            >
              <FaArrowLeft /> Go Back
            </button>
          </div>
        </div>
        {/* <div className="text-black mt-[10px]">
            {subdomain?.asset_description}
          </div> */}

        {/* Quick Stats */}
        <div className="p-1   bg-[#fff]">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 p-4 rounded-lg">
            <BoxComponent
              value={assetData?.data_asset_score ?? "N/A"}
              label="Data Quality"
              iconBg="#80C6AD"
              cardBg="#E6F1F9"
              iconColor="#fff"
            />

            <BoxComponent
              label="Region"
              iconBg="#9897FF"
              cardBg="#E6F1F9"
              iconColor="#fff"
              value={
                <Tooltip
                  title={
                    assetData ? `${assetData.region}, ${assetData.country}` : ""
                  }
                  arrow
                  placement="top"
                >
                  <p className="text-[20px] ">{assetData.parent_region}</p>
                </Tooltip>
              }
            />

            {/* <BoxComponent
              value={
                assetData
                  ? parseInt(assetData.data_row_count).toLocaleString()
                  : "0"
              }
              label="Records"
              iconBg="#0171C1"
              cardBg="#E6F1F9"
              iconColor="#fff"
            /> */}

            <BoxComponent
              label="Data Layer"
              iconBg="#0101A7"
              cardBg="#E6F1F9"
              iconColor="#fff"
              value={
                assetData && assetData.target_layer ? (
                  <div
                    className="inline-block px-3 py-1 rounded-full text-sm font-semibold text-center"
                    style={{
                      backgroundColor: (() => {
                        const type = assetData.target_layer.toLowerCase();
                        switch (type) {
                          case "bronze":
                            return "#CD7F32";
                          case "silver":
                            return "#C0C0C0";
                          case "gold":
                            return "#FFD700";
                          case "ingestion":
                            return "#10B981";
                          default:
                            return "#6B7280";
                        }
                      })(),
                      color: (() => {
                        const type = assetData.target_layer.toLowerCase();
                        switch (type) {
                          case "gold":
                          case "silver":
                            return "#1f2937"; // dark text
                          default:
                            return "white"; // white text for darker backgrounds
                        }
                      })(),
                    }}
                  >
                    {(() => {
                      const type = assetData.target_layer;
                      if (!type) return "N/A";
                      return (
                        type.charAt(0).toUpperCase() +
                        type.slice(1).toLowerCase()
                      );
                    })()}
                  </div>
                ) : (
                  <p className="text-sm text-gray-500">N/A</p>
                )
              }
            />

            <BoxComponent
              value={
                <span className="text-[18px]">
                  {assetData?.frequency || "N/A"}
                </span>
              }
              label="Frequency"
              iconBg="#404040"
              cardBg="#E6F1F9"
              iconColor="#fff"
            />
          </div>
        </div>
        <div></div>
      </div>

        <div className="border-b border-gray-200 mt-0 ">
        <div className="flex justify-between items-center flex-wrap">
          <nav className="flex space-x-8 overflow-x-auto pb-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => !tab.disabled && handleTabClick(tab.id)}
                disabled={tab.disabled}
                className={`whitespace-nowrap flex-shrink-0 flex items-center gap-2 py-3 px-1 border-b-2 font-medium text-sm transition-colors ${
                  tab.disabled
                    ? "border-transparent text-gray-300 cursor-not-allowed"
                    : activeTab === tab.id
                      ? "border-[#bb1ccc] text-[#bb1ccc]"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }`}
              >
                <tab.icon size={18} />
                {tab.label}
                {tab.disabled && (
                  <span className="text-xs text-gray-400 ml-1">
                    (Coming Soon)
                  </span>
                )}
              </button>
            ))}
          </nav>

          {/* Subscribe Button */}
          {/* <button
            onClick={handleSubscribe}
            className="px-4 py-2 rounded-lg bg-[#bb1ccc] text-white flex items-center gap-2 hover:bg-[#000080] transition-colors shadow-md"
            title="Request Access to make your product event driven"
          >
            <KeyIcon size={18} />
            <span>Request Access</span>
          </button> */}
        </div>
      </div>

      {/* Tab Content */}
      <div className="space-y-6">
        {activeTab === "Data Table" && (
          <div className="space-y-6">
            {/* Overview Table with built-in search, sort, and pagination */}
            <div className="overflow-x-auto">
              <AssetDataTable
                tableOverview={tableOverview}
                getTypeColor={getTypeColor}
                itemsPerPage={10}
                id={subdomain.data_asset_id}
                setEditMetadata={setEditMetadata}
              />
            </div>
          </div>
        )}

        {activeTab === "Profiling Result" && (
          <Card>
            <ProfilingResultView results={profilingResultByAsset?.columns} />
          </Card>
        )}

        {activeTab === "DQResult" && (
          <Card>
            {dqResultByAsset?.rules ? (
              <DQResult results={dqResultByAsset} />
            ) : (
              <span>No rules to display</span>
            )}
          </Card>
        )}

        {activeTab === "Data Configuraion" && (
          <div className="space-y-6 px-4 max-h-full">
            {" "}
            <AssetConfiguration assetOverview={assetOverview} />{" "}
          </div>
        )}
      </div>

      {/* Lineage Modal */}
    {activeTab === "Technical Lineage" && (
<div style={{ width: "100%", height: "80vh" ,minHeight:'30vh',overflowY:'auto'}}>
<ViewLineage
      contractData={{
        name: subdomain.data_asset_name,
        source_type: profilingResultByAsset?.source_type,
        filePath: profilingResultByAsset?.file_path,
      }}
    />
</div>
)}
 
{activeTab === "Transformation Lineage" && (
<div style={{ width: "100%",height: selectedMermaid ? "80vh" : "30vh" }}>
    {mermaidLoading ? (
<div className="flex flex-col items-center space-y-3 mt-10">
<img src={heartLoading} alt="Loading..." className="h-30" />
<span className="text-gray-700 text-[20px]">Loading lineage transformation...</span>
</div>
    ) : selectedMermaid ? (
<ReactFlowFromMermaid
        mermaidDiagram={selectedMermaid?.mermaid_diagram || ""}
        summaries={selectedMermaid?.summaries || []}
        selectedMeramaidName={selectedMermaid?.name}
        mermaidTypes={mermaidTypes || []}
        handleSelectMermaid={handleSelectMermaid}
      />
    ) : (
<div className="flex flex-col items-center justify-center h-full w-full space-y-3 mt-10">
<span className="text-gray-700 text-[20px]">No resources found!</span>
</div>
    )}
</div>
)}
{activeTab === "Usage Trend" && (
<div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
<UsageTrend graphData={usageTrendData} loading={usageTrendLoading} />
</div>
)}

      {/* Subscription Modal */}
      {showSubscriptionForm && (
        <SubscriptionModal
          selectedAsset={{
            id: subdomain.data_asset_id,
            name: subdomain.data_asset_name,
          }}
          subscriptionForm={subscriptionForm}
          closeSubsciptionModal={closeSubsciptionModal}
          handleSubscriptionSubmit={handleSubscriptionSubmit}
          handleSubscriptionChange={handleSubscriptionChange}
          setShowSubscriptionForm={setShowSubscriptionForm}
          showSubscriptionForm={showSubscriptionForm}
          allFieldsValid={allFieldsValid}
          formTouched={formTouched}
          formErrors={formErrors}
          products={getAvailableProducts()}
        />
      )}

      <Toaster position="top-right" />
    </div>
  );
};
